const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  storeid: state => state.user.storeid,
  orderlist_date: state => state.page.actionRecord.orderlist_date
}
export default getters
